<div class="dialog-wrapper">
  <div class="c-dialog-content">
    <p class="c-dialog-text mb-12-px mt-unset">Inform me when this item becomes available:</p>
    <div class="mb-28-px">
      <div class="selected-item">
        <app-product-image-wrapper>
          <div class="img-wrapper">
            <img [src]="dialogData?.featuredAsset | assetPreview:'thumb'" [alt]="dialogData?.name">
          </div>
        </app-product-image-wrapper>
        <app-product-details-header [name]="dialogData?.name" [slug]="dialogData?.slug"
          [manufacturer]="dialogData?.manufacturer" [small]="true" [showCodeAndBrandLine]="false"
          [brandAndNameInline]="true" [showLabels]="false"></app-product-details-header>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="row">
        <div class="col-12">
          <app-inline-input-control [type]="'number'" [control]="form.controls[RequestItemFields.Quantity]"
            [label]="'Amount needed:'" [name]="RequestItemFields.Quantity"></app-inline-input-control>
        </div>
        <div class="col-12">
          <app-inline-input-control [type]="'number'" [control]="form.controls[RequestItemFields.Phone]"
            [label]="'Your phone:'" [name]="RequestItemFields.Phone"></app-inline-input-control>
        </div>
        <div class="col-12">
          <app-inline-input-control [type]="'email'" [control]="form.controls[RequestItemFields.Email]"
            [label]="'Your email:'" [name]="RequestItemFields.Email"></app-inline-input-control>
        </div>
        <div class="col-12">
          <div class="textarea-wrapper mb-16 primary">
            <textarea placeholder="Your comments" id="{{ RequestItemFields.Comments }}" rows="5" cols="30"
              pInputTextarea formControlName="{{ RequestItemFields.Comments }}"></textarea>
          </div>
        </div>
      </div>


    </form>
  </div>
  <div class="c-dialog-actions">
    <button (click)="closeDialog()" pButton pRipple class="c-button light cancel">Cancel</button>
    <button [disabled]="!form.valid || loading" (click)="submitRequestItem()" pButton pRipple
      class="c-button primary save">Submit</button>
  </div>
</div>
